module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct1",
    attrs: {
      "id": "d7e112316"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Auth_ISBN9781402790959_epub_toc_r1#d7e2926",
      "id": "d14e409"
    }
  }, [_vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NTRODUCTION ")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e112816"
    }
  }, [_vm._v("“W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAT DID YOU FEEL?” ")]), _vm._v("“What were you thinking about?” “Who came to mind?” These were just some of the questions members of the audience asked me after I had recited the Kaddish (mourners’ prayer) and selected verses from Psalms. We were at Auschwitz-Birkenau, at a ceremony commemorating the sixtieth anniversary of the liberation of the camp. A heavy snow was falling in the freezing cold, and for the entire three hours, I pitied the thousands of participants, including the president of the State of Israel, the vice president of the United States, and the presidents and prime ministers of the major European countries.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e116016"
    }
  }, [_vm._v("With closed eyes, I recited from Psalms: "), _c('i', [_vm._v("Yea, though I walk through the valley of the shadow of death, I will fear no evil, for thou art with me … and thou hast delivered my soul from death… . I will walk before the Lord in the land of the living.")]), _vm._v(" I ended with the Kaddish: "), _c('i', [_vm._v("Yitgadal ve-yitkadash shemeh rabbah")]), _vm._v("—Sanctified and magnified be Your great Name.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e118716"
    }
  }, [_vm._v("My eyes were closed, but I saw the victims clearly. In my mind’s eye, they were getting off the train cars beside me. I saw them as they stood for the “selection,” "), _c('i', [_vm._v("those for death and those for life,")]), _vm._v(" right at that very spot. I saw the shocked look in their eyes when they realized they had been deceived. I saw the Gestapo men and their Ukrainian henchmen beating and pushing them, and with them the vicious dogs,"), _c('a', {
    attrs: {
      "id": "id2"
    }
  }), _vm._v(" cavernous mouths snarling. I saw the soldiers tearing children and babies from their parents’ embrace. I saw families broken apart with savage cruelty. Three things linked to the nightmares of my childhood disturb me to this day: trains, boots, and dogs.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e123117"
    }
  }, [_vm._v("I heard the shouts: "), _c('i', [_vm._v("“Schnell, schnell!”")]), _vm._v("—faster, faster! I heard the barks.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e124017"
    }
  }, [_vm._v("I heard the screams of the children: "), _c('i', [_vm._v("“Mameh! Tateh!”")]), _vm._v(" I heard the bitter cries of the mothers and saw the bloody faces of the fathers beaten with rifle butts because they had tried to protect the children in their arms.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e125817"
    }
  }, [_vm._v("Although that recital of the Kaddish on January 27, 2005, was an isolated event, this book will act as an eternal light, an everlasting memorial that will tell the coming generations about the events in that dark tunnel, about the sparks of light that broke through it, and about the hope and faith that followed."), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e127917"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HIS BOOK IS NOT ")]), _vm._v("a conventional autobiography. You will not read here about the forty-four years that I served in the rabbinate, at every stage from rabbi of a low-income neighborhood in Tel Aviv to chief rabbi of Israel. Instead, the stories here are about my personal memories of the Holocaust, my escape from its fiery furnace, its tortures of body and soul, and how I grew up without parents or a home. This book also tells about my acquaintance with some very special individuals, both Jews and non-Jews, who were instrumental in the national and personal miracle of rescue, the building of a national home in our native land, and the transition from Holocaust to revival.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e131917"
    }
  }, [_vm._v("Over time, the blazing flames of the survivors have died down to glowing embers, which by their very nature dwindle until they are extinguished. I am attempting to fan the flames of these embers so that they will never die out. I hope that my story will touch the consciousness of readers and bestir them to think again, to search their souls, and perhaps even to conclude that despite all the enigmas posed by the Holocaust, "), _c('i', [_vm._v("I will walk before the Lord in the land of the living")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e135017"
    }
  }, [_vm._v("When King Solomon dedicated the Temple, he announced, "), _c('i', [_vm._v("The Lord said that He would dwell in thick darkness")]), _vm._v(". Sometimes, the Divine Presence rests within a domain that is hidden, concealed behind a screen of mystery."), _c('a', {
    attrs: {
      "id": "id3"
    }
  }), _vm._v(" The great Chassidic teacher Rabbi Menachem Mendel of Kotsk used to say, “I am not capable of worshipping a God whose every path is clear to me.” When everything is revealed and understood, that is friendship, not Divinity. When Joseph makes his enigmatic demand that his brothers bring Benjamin to him, he says, "), _c('i', [_vm._v("By this you shall be tested")]), _vm._v(". Faith is tested through the unfathomable and the inexplicable.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e140018"
    }
  }, [_vm._v("I am a believer—and I will remain so until my dying day; "), _c('i', [_vm._v("God has tried me with suffering, but He has not given me over to death")]), _vm._v(". I do not believe in coincidence, but in Divine Providence. The question for which I have not found an answer remains the question of why. Why did it have to happen? Why was my brother Milek, may God avenge his death, torn from our mother to go to his death, while I was separated from her and lived? I will never know, but this will not diminish my faith in the "), _c('i', [_vm._v("One Who spoke and created the world")]), _vm._v(". As we repeat every morning in the prayer service, "), _c('i', [_vm._v("into His hand I will entrust my spirit")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e144518"
    }
  }, [_c('i', [_vm._v("I will pay my vows to the Lord, in the presence of all His people.")]), _vm._v(" Every day when I awake, I recite with complete conviction, "), _c('i', [_vm._v("I gratefully thank You, O living and eternal King, for You have returned my soul to me with compassion")]), _vm._v("."), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e146818"
    }
  }, [_vm._v("I "), _c('span', {
    staticClass: "small"
  }, [_vm._v("CONCLUDE WITH A PRAYER ")]), _vm._v("to the Creator of the universe, that "), _c('i', [_vm._v("nation shall not lift up sword against nation, neither shall they learn war any more")]), _vm._v(". I pray that no child in the entire world will ever have to traverse the tortured path my companions and I were forced to take until we arrived, like "), _c('i', [_vm._v("children returning home")]), _vm._v("."), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "txr",
    attrs: {
      "id": "d7e150018"
    }
  }, [_c('i', [_vm._v("Tel Aviv-Jaffa")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e789836","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Auth_ISBN9781402790959_epub_c10_r1.vue
// module id = 84
// module chunks = 0